// simple component to handle the error message depending on the users role and permissions
import React from 'react';
import { hasRole, RoleTypes } from './Permission';
import { hasUserPermission } from './UserPermissions';
import { useSelector } from 'react-redux';
import { selectRole } from '../../store/authReducer';
import { selectPermissions } from '../../store/authReducer';
import { useIntl } from 'react-intl';
import { findPermissionRef, viewPermissionRefs } from './UserGroupPermissions';
interface ErrorMessageHandlerProps {
  errorMessage: string;
}

const ErrorMessageHandler = ({ errorMessage }: ErrorMessageHandlerProps) => {
  const role = useSelector(selectRole);
  const permissions = useSelector(selectPermissions);
  const intl = useIntl();

  if (
    hasRole(role, RoleTypes.Admin) ||
    findPermissionRef(permissions, viewPermissionRefs.admin) ||
    hasRole(role, RoleTypes.Operator)
  ) {
    return <div>{errorMessage}</div>;
  }

  return <div>{intl.formatMessage({ id: 'genericErrorMessage' })}</div>;
};

export default ErrorMessageHandler;
